import { Link, NavLink } from 'react-router-dom';
import { useState } from 'react';
import './Ubicacion.css';
import { useLanguage } from '../i18n/LanguageContext';

export default function Ubicacion() {
  const { t, lang, toggleLanguage } = useLanguage();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const mensaje = `Nombre: ${formData.name}%0AEmail: ${formData.email}%0ATeléfono: ${formData.phone}%0AAsunto: ${formData.subject}%0AMensaje: ${formData.message}`;
    window.open(`https://wa.me/50662857770?text=${mensaje}`, '_blank');
    setSubmitted(true);
    setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <div className="app">
      <header className="page-hero">
        <nav className="nav">
          <Link to="/" className="brand-link">
            <img
              src="/ceam-logo.png"
              className="brand-logo"
              alt="Centro Educativo Adventista de Monteverde"
            />
            <div className="brand-text">
              <span className="brand-title">{t('common.brand')}</span>
              <span className="brand-subtitle">{t('common.schoolName')}</span>
            </div>
          </Link>
          <div className="nav-actions">
            <NavLink to="/" className="btn ghost">{t('nav.home')}</NavLink>
            <NavLink to="/admisiones" className="btn ghost">{t('nav.admissions')}</NavLink>
            <NavLink to="/acerca-de" className="btn ghost">{t('nav.about')}</NavLink>
            <NavLink to="/ubicacion" className="btn ghost">{t('nav.contact')}</NavLink>
            <NavLink to="/voluntariado" className="btn ghost">{t('nav.volunteer')}</NavLink>
            <button type="button" className="btn ghost lang-toggle" onClick={toggleLanguage}>
              {lang === 'es' ? 'EN' : 'ES'}
            </button>
          </div>
        </nav>
      </header>

      <section className="section location-intro">
        <h1>{t('location.title')}</h1>
        <p className="lead">{t('location.lead')}</p>
      </section>

      <section className="section alt location-section">
        <div className="location-container">
          <div className="map-wrapper">
            <h2>{t('location.locationTitle')}</h2>
            <div className="map-frame">
              <iframe
                src="https://www.google.com/maps?q=Centro%20Educativo%20Adventista%20de%20Monteverde&output=embed"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicación CEAM"
              ></iframe>
            </div>
          </div>

          <div className="form-wrapper">
            <h2>{t('location.formTitle')}</h2>
            {submitted && <div className="success-message">{t('location.success')}</div>}
            
            <form onSubmit={handleSubmit} className="contact-form-page">
              <div className="form-group">
                <label htmlFor="name">{t('location.name')}</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder={t('location.namePlaceholder')}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">{t('location.email')}</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder={t('location.emailPlaceholder')}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="phone">{t('location.phone')}</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder={t('location.phonePlaceholder')}
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">{t('location.subject')}</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder={t('location.subjectPlaceholder')}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">{t('location.message')}</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder={t('location.messagePlaceholder')}
                  rows="5"
                ></textarea>
              </div>
              
              <button type="submit" className="btn primary btn-full">{t('location.send')}</button>
            </form>
          </div>
        </div>
      </section>

      <section className="section info-section">
        <h2>{t('location.infoTitle')}</h2>
        <div className="info-grid">
          <div className="info-card">
            <h3>📱 {t('common.whatsapp')}</h3>
            <a href="https://wa.me/50662857770" target="_blank" rel="noopener noreferrer">
              +506 6285 7770
            </a>
            <p>{t('common.weekHours')}</p>
            <p>{t('common.weekendHours')}</p>
          </div>
          
          <div className="info-card">
            <h3>📧 {t('common.address')}</h3>
            <a href="mailto:info@ceam.ed.cr">
              info@ceam.ed.cr
            </a>
          </div>
          
          <div className="info-card">
            <h3>💰 {t('common.accounting')}</h3>
            <a href="mailto:contabilidad@ceam.ed.cr">
              contabilidad@ceam.ed.cr
            </a>
          </div>

          <div className="info-card">
            <h3>🌐 {t('common.website')}</h3>
            <a href="https://www.ceam.ed.cr" target="_blank" rel="noopener noreferrer">
              www.ceam.ed.cr
            </a>
          </div>

          <div className="info-card">
            <h3>{t('common.facebook')}</h3>
            <a href="https://www.facebook.com/CEAdventistaM?locale=es_LA" target="_blank" rel="noopener noreferrer">
              @CEAdventistaM
            </a>
          </div>

          <div className="info-card">
            <h3>⏰ {t('common.schedule')}</h3>
            <p>{t('common.weekHours')}</p>
            <p>{t('common.weekendHours')}</p>
          </div>

          <div className="info-card">
            <h3>📋 {t('common.enrollment2026')}</h3>
            <p>{t('common.enrollmentOpen')}</p>
            <p>{t('common.familyInvite')}</p>
          </div>
        </div>
      </section>

      <footer className="footer">
        <p>{t('footer.rights')}</p>
      </footer>
    </div>
  );
}
